import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AngularFireDatabase } from 'angularfire2/database';
import { ApiService } from 'app/services/api';
import { OAuthService } from 'app/services/o-auth';

@Component({
  selector: 'app-creator-detail-component',
  templateUrl: './creator-detail-component.component.html',
  styleUrls: ['./creator-detail-component.component.scss']
})
export class CreatorDetailComponentComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private fireDatabase: AngularFireDatabase,
    private oAuthService: OAuthService,
    private apiService: ApiService,
  ) { }
  public user;
  public tournament: any;
  public tournamentId;
  ngOnInit() {
    this.user = this.oAuthService.getClub();
    this.tournamentId = this.route.snapshot.paramMap.get("id");

    this.fireDatabase.database.ref(`/multi-round/${this.tournamentId}`).on("value", result => {
      this.tournament = result.val();
      Object.assign(this.tournament,{$key: this.tournamentId})
      this.init();
    });
  }
  async init(){
     let uid = this.tournament.userId
      ? this.tournament.userId
      : this.tournament.uid;
    let user = await this.apiService.object("users/" + uid);
    let profile = await this.apiService.object(
      "user-profiles/" + uid + "/" + this.user.cid
    );
    user.profile = profile;
    this.tournament.user = user;
  }

  goBack()
  {
    window.history.back();
  }
}
